import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import AttendanceServices from "../../../services/AttendanceServices";
import VehicleServics from "../../../services/VehicleServics";
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2

const AttendenceReport = () => {
    const [vehicles, setVehicles] = useState([]); // State for storing vehicles
    const [selectedVehicle, setSelectedVehicle] = useState("all"); // State for dropdown value
    const [expandedRow, setExpandedRow] = useState(null);
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("all");
    const [totalcount, setTotalCount] = useState(0)

    useEffect(() => {
        // Fetch vehicle details when the component mounts
        VehicleServics.getVehicle()
            .then(response => {
                if (response?.data?.data) {
                    setVehicles(response?.data?.data); // Assuming response.data contains the vehicle list
                }
            })
            .catch(error => {
                console.error("Error fetching vehicles:", error);
            });
    }, []);


    const fetchReport = async () => {
        if (!fromDate || !toDate) {
            Swal.fire({
                icon: "warning",
                title: "Missing Dates",
                text: "Please select both From and To dates.",
            });
            return;
        }

        setLoading(true);
        try {
            const response = await AttendanceServices.attendenceReport({ fromDate: fromDate, toDate: toDate, vehicle: selectedVehicle })
            setReportData(response.data);
            setTotalCount(response.count)
            Swal.fire({
                icon: "success",
                title: "Report Generated",
                text: `Report Successfully Generated for the Selected Date Range.`,
            });
        } catch (error) {
            console.error("Error fetching report data:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch report data. Please try again later.",
            });
        } finally {
            setLoading(false);
        }
    };

    const downloadExcel = () => {
        if (reportData.length === 0) {
            Swal.fire({
                icon: "info",
                title: "No Data",
                text: "No data available to download.",
            });
            return;
        }

        // Format data for Excel
        const formattedData = reportData.map((item, index) => ({
            "S.No": index + 1,
            "Date": item?.startTime?.split("T")[0] || "",
            "Store": item?.store?.name || "",
            "Machine Name": item?.vehicle?.name || "",
            "Driver Name": item?.driver?.name || "",
            "Start Time": formatDate(item?.startTime),
            "Start HMR": item?.startKM || "",
            "End Time": formatDate(item?.endTime),
            "End HMR": item?.endKM || 0,
            "Day HMR": handleHMR(item?.startKM, item?.endKM).toFixed(2) || 0,
            "Diesel Qty": (item?.desile?.reduce((sum, diesel) => sum + diesel.desileQty, 0) || 0).toFixed(2),
            "Diesel Details": item?.desile?.map(diesel => `Qty: ${diesel.desileQty}, Reading: ${diesel.reading}, Date: ${new Date(diesel.diseleFilupDate).toLocaleString()}`).join("\n") || "No Details",
            "Current Status": item?.status || "",
            "Updated Date": item?.updatedAt?.split("T")[0] || "",
            "Start Reading Img": item?.meterPhotos?.start
                ? `https://indigoinfra.in/img/requisitionform/${item?.meterPhotos?.start}`
                : "No Image",
            "End Reading Img": item?.meterPhotos?.end
                ? `https://indigoinfra.in/img/requisitionform/${item?.meterPhotos?.end}`
                : "No Image",
        }));

        // Create a new workbook and sheet
        const now = new Date();
        const date = now.toISOString().split("T")[0]; // YYYY-MM-DD format
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // HH-MM-SS format
        const fileName = `Machine_Log_${date}_${time}.xlsx`;

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Machine Log");

        // Export to Excel with the dynamic file name
        XLSX.writeFile(workbook, fileName);
        Swal.fire({
            icon: "success",
            title: "Download Successful",
            text: `File "${fileName}" has been downloaded successfully.`,
        });
    };


    //date format

    const formatDate = (isoString) => {
        if (!isoString) return "N/A"; // Handle undefined/null values

        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "N/A"; // Handle invalid date values

        // Extract date parts using `toLocaleString`
        const day = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit" });
        const month = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", month: "2-digit" });
        const year = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", year: "numeric" });
        const hours = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", hour12: false });
        const minutes = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", minute: "2-digit" });
        const seconds = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", second: "2-digit" });

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    let HMR = 0;

    function handleHMR(start, end) {
        if (!end) {
            return 0; // Return 0 if `end` is undefined or falsy
        }

        let difference = end - start; // Calculate difference
        HMR += difference; // Update HMR

        return difference; // Return the calculated difference
    }


    const toggleRow = (index) => {
        setExpandedRow((prev) => (prev === index ? null : index));
    };


    return (
        <>
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                onClick={() => setOpen(!open)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">From</label>
                                        <input
                                            type="date"
                                            name="fromDate"
                                            className="form-control mb-xxl-0 mb-3"
                                            value={fromDate}
                                            onChange={(e) => setFromDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">To</label>
                                        <input
                                            type="date"
                                            name="toDate"
                                            className="form-control mb-xxl-0 mb-3"
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-xl-3 col-xxl-3">

                                        <label className="ms-2">Machine</label>
                                        <select
                                            className="form-select"
                                            value={selectedVehicle}
                                            style={{ height: "55px" }}
                                            onChange={(e) => setSelectedVehicle(e.target.value)}
                                        >
                                            <option value="all">All</option>
                                            {vehicles.map((vehicle) => (
                                                <option key={vehicle._id} value={vehicle._id}>
                                                    {vehicle.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Search</label>
                                        <button
                                            className="form-control btn btn-primary"
                                            onClick={fetchReport}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Generate Report"}
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fa fa-list me-2" aria-hidden="true"></i>Machine Log<span className="badge bg-orange ms-2">{totalcount}</span>
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="mb-3 text-end">
                                    {!loading && reportData?.length > 0 && (
                                        <p onClick={downloadExcel} className="text-end btn btn-rounded btn-md btn-primary me-3">
                                            <i className="las la-download scale5 me-3"></i> Download Report
                                        </p>
                                    )}
                                </div>

                                <div className="scrolltable">
                                    <table className="table table-bordered table-striped">
                                        <thead
                                            className="sticky-table-header"
                                        >
                                            <tr>
                                                <th>S.No</th>
                                                <th>Date</th>
                                                <th>Store</th>
                                                <th>Machine Name</th>
                                                <th>Driver Name</th>
                                                <th>Start Time</th>
                                                <th>Start HMR</th>
                                                <th>End Time</th>
                                                <th>End HMR</th>
                                                <th>Day HMR</th>
                                                <th>Diesel Qty</th>
                                                <th>Diesel Details</th>
                                                <th>Current Status</th>
                                                <th>Updated Date</th>
                                                <th>Start Reading Image</th>
                                                <th>End Reading Image</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportData.length > 0 ? (
                                                <>
                                                    {reportData.map((item, index) => {
                                                        const totalDieselQty = item?.desile?.reduce((sum, diesel) => sum + diesel.desileQty, 0) || 0;
                                                        return (
                                                            <>
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item?.startTime.split("T")[0]}</td>
                                                                    <td className="scrollable-description">{item?.store?.name}</td>
                                                                    <td>{item?.vehicle?.name}</td>
                                                                    <td>{item?.driver?.name}</td>
                                                                    <td>{formatDate(item?.startTime)}</td>
                                                                    <td>{item?.startKM}</td>
                                                                    <td>{formatDate(item?.endTime)}</td>
                                                                    <td>{item?.endKM}</td>
                                                                    <td>{handleHMR(item?.startKM, item?.endKM).toFixed(2)}</td>
                                                                    <td>{totalDieselQty.toFixed(2)}</td>
                                                                    <td>
                                                                        {item?.desile?.length > 0 && (
                                                                            <button
                                                                                className="btn btn-success btn-sm"
                                                                                onClick={() => toggleRow(index)}
                                                                            >
                                                                                {expandedRow === index ? "Hide Details" : "Show Details"}
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    <td>{item?.status}</td>
                                                                    <td>{item?.updatedAt.split("T")[0]}</td>
                                                                    <td className="scrollable-description">
                                                                        {item?.meterPhotos?.start ? (
                                                                            <span
                                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                                                onClick={() => window.open(`https://indigoinfra.in/img/requisitionform/${item?.meterPhotos?.start}`, "_blank")}
                                                                            >
                                                                                View Image-{item?.meterPhotos?.start}
                                                                            </span>
                                                                        ) : (
                                                                            "No image available"
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {item?.meterPhotos?.end ? (
                                                                            <span
                                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                                                onClick={() => window.open(`https://indigoinfra.in/img/requisitionform/${item?.meterPhotos?.end}`, "_blank")}
                                                                            >
                                                                                View Image-{item?.meterPhotos?.end}
                                                                            </span>
                                                                        ) : (
                                                                            "No image available"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                {expandedRow === index && (item?.desile?.length || 0) > 0 && (
                                                                    <tr>
                                                                        <td colSpan="17" style={{ textAlign: "center" }}>
                                                                            <div style={{ display: "inline-block" }}>
                                                                                <table className="table table-bordered">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>S.No</th>
                                                                                            <th>Diesel Qty</th>
                                                                                            <th>Reading</th>
                                                                                            <th>Diesel Fill-up Date</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {item.desile.map((diesel, dIndex) => (
                                                                                            <tr key={diesel._id}>
                                                                                                <td>{dIndex + 1}</td>
                                                                                                <td>{diesel.desileQty}</td>
                                                                                                <td>{diesel.reading}</td>
                                                                                                <td>{new Date(diesel.diseleFilupDate).toLocaleString()}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                        );
                                                    })}
                                                    <tr className="bg-primary font-weight-bold">
                                                        <td colSpan="9" className="text-right fw-bolder fs-4">Total</td>

                                                        <td className="text-right fw-bolder fs-4">
                                                            {reportData.reduce((total, item) => total + handleHMR(item?.startKM, item?.endKM), 0).toFixed(2)}
                                                        </td>
                                                        <td className="text-right fw-bolder fs-5">
                                                            {reportData.reduce((total, item) => total + (item?.desile?.reduce((sum, diesel) => sum + diesel.desileQty, 0) || 0), 0).toFixed(2)}
                                                        </td>

                                                        <td colSpan="5"></td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan="17" className="text-center">No data available.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </>
    );
};

export default AttendenceReport;
